import useSendPasswordOtp from "@/services/auth/hooks/useSendPasswordOtp";
import { phoneNumberValidation } from "@/utilities/validation";
import { Button, Stack, TextInput } from "@mantine/core";
import { useForm, yupResolver } from "@mantine/form";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";

const schema = Yup.object().shape({
  phoneNumber: Yup.string()
    .required("شماره تلفن را وارد نمایید")
    .matches(phoneNumberValidation, "شماره تلفن را به درستی وارد نمایید"),
});

const ForgetPasswordPhoneNumber = () => {
  const location = useLocation();
  const { phoneNumber } = location.state;
  const navigate = useNavigate();
  const { isLoading, mutate } = useSendPasswordOtp();
  const form = useForm({
    initialValues: { phoneNumber: phoneNumber },
    validate: yupResolver(schema),
  });
  return (
    <Stack justify="center" h={300}>
      <form
        onSubmit={form.onSubmit((values) => {
          mutate(
            {
              username: values?.phoneNumber,
            },
            {
              onSuccess() {
                navigate("/auth/forgetPasswordCheckOtp", {
                  state: {
                    phoneNumber,
                  },
                });
              },
            }
          );
        })}
        className="w-100"
      >
        <Stack>
          <TextInput
            styles={{
              input: {
                direction: "ltr",
                textAlign: "left",
              },
              description: {
                fontSize: "0.8rem",
              },
              error: {
                fontSize: "0.8rem",
              },
            }}
            size="lg"
            type="tel"
            label="بازیابی رمز عبور"
            description="لطفا شماره موبایل را وارد کنید"
            maxLength={11}
            {...form.getInputProps("phoneNumber")}
          />
          <Button
            type="submit"
            size="md"
            mt="md"
            className="w-100"
            loading={isLoading}
          >
            ادامه
          </Button>
        </Stack>
      </form>
    </Stack>
  );
};

export default ForgetPasswordPhoneNumber;
